import * as yup from 'yup';
import docs from './attachments';
import {
  aceite,
  aceiteAlteracaoDadosBancarios,
  aceiteInss,
  consentimentoDadosSensiveis,
  dataAposentadoria,
  declaracao,
  declaracaoTipoRegime,
  declaracaoVeracidade,
  estaAposentadoINSS,
  numeroDoBeneficio,
  parcelasDoPagamento,
  tipoRegime,
} from './utils/rulesByKey';

export const ResgateTaesaSchema = yup.object({
  ...estaAposentadoINSS,
  ...dataAposentadoria,
  ...numeroDoBeneficio,
  ...parcelasDoPagamento,
  ...declaracao,
  ...declaracaoTipoRegime,
  ...tipoRegime,
  ...aceiteAlteracaoDadosBancarios,
  ...aceite,
  ...consentimentoDadosSensiveis(),
  ...declaracaoVeracidade,
  ...docs.ResgateTaesaDocs.rules,
  ...aceiteInss,
});

export const ResgateTaesaInitialValues = {
  estaAposentadoINSS: '',
  dataAposentadoria: '',
  numeroDoBeneficio: '',
  parcelasDoPagamento: '',
  tipoRegime: '',
  consentimentoDadosSensiveis: false,
  aceiteInss: false,
  declaracao: false,
  declaracaoTipoRegime: false,
  aceiteAlteracaoDadosBancarios: false,
  aceite: false,
  declaracaoVeracidade: false,
  ...docs.ResgateTaesaDocs.initialValues,
};

export const ResgateTaesaDocs = {
  ...docs.ResgateTaesaDocs.docs,
};
